module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1200.b5ee66ad.svg";